import { TeamCard } from "./TeamCard";
import type { TeamCardProps } from "./TeamCard.d";

export { TeamCard, TeamCardProps };
